angular.module('lf.common')

.directive('customerServiceForm', function () {
  return {
    scope: true,
    controller: CSFormController,
    link: function () {}
  }
});

function CSFormController ($scope, $http, scrolls) {
  
  $scope.formData = $.extend(true, {}, window.csFormData);
  $scope.form = {};
  
  $scope.onSelectCountry = function onSelectCountry () {
    console.log('onSelectCountry() country: ', $scope.form.countryCode);
  }
  
  $scope.onSelectProduct = function onSelectProduct () {
    var product = _.where($scope.formData.products, { value: $scope.form.product })[0];
    if (product) {
      $scope.formData.categories = product.categories;
      resetCategoryField();
      resetSubCategoriesFields();
      console.log('onSelectProduct() product:', product);
    }
  }
  
  $scope.onSelectCategory = function onSelectCategory () {
    console.log('onSelectCategory() category: ', $scope.form.category);
  }
  
  function resetCategoryField () {
    $scope.form.category = null;
    if ($scope.csForm.category) {
      $scope.csForm.category.$setPristine();
      $scope.csForm.category.$setUntouched();
    }
  }
  
  function resetSubCategoriesFields () {
    $scope.form.subCategory1 = null;
    if ($scope.csForm.subCategory1) {
      $scope.csForm.subCategory1.$setUntouched();
      $scope.csForm.subCategory1.$setPristine();
    }

    $scope.form.subCategory2 = null;
    if ($scope.csForm.subCategory2) {
      $scope.csForm.subCategory2.$setUntouched();
      $scope.csForm.subCategory2.$setPristine();
    }
  }
  
  $scope.submit = function submit () {
    var form = $.extend(true, {}, $scope.form);
    
    form.country = _.where($scope.formData.countries, { value: form.countryCode })[0].text;
    
    if (form.category === 'CRACKED_SCREEN') {
      form.category = _.where($scope.formData.categories, { value: 'CRACKED_SCREEN' })[0].text;
      if (form.subCategory1 && form.subCategory2) {
        form.subCategory1 = _.where($scope.formData.subCategory1, { value: form.subCategory1 })[0].text;
        form.subCategory2 = _.where($scope.formData.subCategory2, { value: form.subCategory2 })[0].text;
      }
    } else {
      form.subCategory1 = null;
      form.subCategory2 = null;
    }
    
    console.log(form, $.param(form));

    $scope.isRequesting = true;
    $scope.error = null;
    
    $http({
      method: 'POST',
      url: window.csFormConfig.handlerUrl,
      data: $.param(form),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
      .success(function (data) {
        if (data && data.status) {
          $scope.formSent = true;
          setTimeout(function () {
            scrolls.scrollTop();
          }, 50);
        } else {
          $scope.error = { serverError: true };
        }
      })
      .error(function (data, status) {
        $scope.error = {};
        if (data && data.data && data.data.message) {
          $scope.error.message = data.data.message;
        } else {
          $scope.error.serverError = true;
        }
      })
      .finally(function () {
        $scope.isRequesting = false;
      });
  }
  
  $scope.isBrowserSupported = function isBrowserSupported () {
    // IE <= 9 & iOS < 7 not supported
    var ua = navigator.userAgent;
    var ie = ua.match(/MSIE (\d+)\.\d+/);
    var ios = ua.match(/iP(hone|od|ad).+?OS (\d)_(\d)/);
    
    if ((ie && +ie[1] <= 9) || 
        (ios && +ios[2] < 7)) {
      return false;
    }
    
    return true;
  }
  
}
